/// Trim a free-form emoji string down to a single grapheme cluster so a
/// user pasting "🎉🎂" or "🎉 extra text" still saves cleanly. Falls back to
/// a sensible default if the input is empty after trimming.
export function firstGrapheme(s: string, fallback = '🎉'): string {
  const trimmed = s.trim();
  if (!trimmed) return fallback;
  if (typeof Intl !== 'undefined' && 'Segmenter' in Intl) {
    const seg = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
    for (const part of seg.segment(trimmed)) {
      return part.segment;
    }
  }
  return trimmed.slice(0, 4) || fallback;
}
